// IMPORTS
// Assets
import icon_ethernet from './../../../../../onehivesystems/icons/ethernet_dark.svg';
import icon_fiber from './../../../../../onehivesystems/icons/sfp_dark.svg';
import icon_power from './../../../../../onehivesystems/icons/nema_dark.svg';
import icon_video from './../../../../../onehivesystems/icons/vga_dark.svg';
import icon_usb from './../../../../../onehivesystems/icons/usb_dark.svg';
import icon_genericport from './../../../../../onehivesystems/icons/target_dark.svg';


// COMPONENT
export default function PortTypeImage (props) {
   // Component
   return (
      <>
         {props.value === "Ethernet" && <img src={icon_ethernet} alt='Ethernet' />}
         {props.value === "Fiber" && <img src={icon_fiber} alt='Fiber' />}
         {props.value === "Power" && <img src={icon_power} alt='Power' />}
         {props.value === "Video" && <img src={icon_video} alt='Video' />}
         {props.value === "USB" && <img src={icon_usb} alt='USB' />}
         {props.value === "Generic" && <img src={icon_genericport} alt='Generic Port' />}
      </>
   );
}